import React, { useEffect, useState } from "react";

//CSS
import "./colorCircle.css";

//Components
import CustomColorPicker from "./customColorPicker";

//Functions and hooks
import { usePopup } from "../../Contexts/PopupContext";

export default function ColorCircle({
  color = "hsl(0, 0%, 100%)",
  circleSize,
  clickable = true,
  onChange,
}) {
  const [selectedColor, setSelectedColor] = useState(color);

  const { showPopup, removePopup } = usePopup();

  const openColorPicker = () => {
    const key = Date.now();
    showPopup(
      <CustomColorPicker
        initialColor={selectedColor}
        onSelectColor={handleColorSelect}
        onCancel={() => {
          removePopup(key);
        }}
      />,
      key
    );
  };

  useEffect(() => {
    setSelectedColor(color);
    console.log("color", color);
  }, [color]);

  const SIZES = ["circle-small", "circle-medium", "circle-large"];

  const handleCircleClick = () => {
    if (clickable) openColorPicker();
  };

  const handleColorSelect = (newColor) => {
    setSelectedColor(newColor);
    if (onChange) {
      onChange(newColor);
    }
  };
  return (
    <div className="color-circle-container">
      <div
        className={`color-circle ${
          SIZES.includes(circleSize) ? circleSize : SIZES[1]
        }`}
        style={{ backgroundColor: selectedColor }}
        onClick={handleCircleClick}
      ></div>
    </div>
  );
}
